/**
 * 数据权限相关处理
 * @param {*} 元数据配置：前端自定义参数 { ENAME: 'CP_C_SHOP_TITLE' }
 * @param {*} ENAME 数据权限勾选行，id对应展示的名称，如平台店铺CP_C_SHOP_TITLE，默认ENAME
 */
const tableName = () => vm.$route.params.tableName
const cmd = () => `${tableName()}_ALL` // 【添加全部】webname格式：表名_ALL

// iframe是否数据权限页面
const isPermission = () => {
  let flag = false
  if (vm.$route.query.iframe == 'true' && vm.$route.query.permission == 'true') {
    flag = true
  }
  return flag
}

const response = (config) => {
  if (config.config.url == '/p/cs/QueryList') {
    if (isPermission()) {
      window.dispatchEvent(new CustomEvent('permePage')) // 重写列表事件回调
    }
  }
}

// 列表按钮显隐
const hideBtn = (res) => {
  const { iframe, permission } = vm.$route.query
  const { data: { datas, tabcmd, waListButtons } } = res
  let n_prem = tabcmd.prem
  let n_waListButtons = waListButtons
  let isPermission = iframe == 'true' && permission == 'true'
  if (isPermission) {
    // iframe标准列表显示【添加全部】，隐藏其他按钮
    n_prem = n_prem.map(i => i = false)
    n_waListButtons = waListButtons.filter(i => i.webname == cmd())
  } else {
    // 正常标准列表隐藏【添加全部】
    waListButtons && (n_waListButtons = waListButtons.filter(i => i.webname != cmd()))
  }
  return { prem: n_prem, waListButtons: n_waListButtons }
}

// 按钮-添加全部
const PERMISSION_ADD_ALL = () => {
  $utils.getFixedcolumns().then(res => {
    const tableName = vm.$route.params.tableName
    const newDate = definedVal(res)
    const cb = (row) => {
      return row.map(i => {
        return `${i.colname}${i.value}`
      }).join('')
    }
    let isExist = false
    let store = vm.$store.state.omsStore.permissionConds[tableName]
    if (store) {
      isExist = store.map(row => cb(row)).some(i => i == cb(newDate))
    }
    // 去重
    if (isExist) return $fcWarn({ content: t('该条件已存在！') })
    if (!newDate.length) return $fcWarn({ content: t('请维护条件！') })
    vm.$store.commit('omsStore/up_permissionConds', { tableName, data: newDate });
    // 触发通知监听
    window.dispatchEvent(new CustomEvent('permeConds'))
  })
}

// 查询条件是defined处理
const definedVal = (res) => {
  if (tableName() == 'PS_C_PRO') {
    res.forEach(i => {
      if (i.colname == 'MODIFIERNAME') { // 类目
        i.colname = 'PS_C_CATEGORY_ID'
        const valuedesc = $('#MODIFIERNAME')[0].__vue__.$children[0].$children[0].checkedNodeArr.map(i => i.title)
        i.valuedesc = valuedesc
        i.label = `${i.coldesc} ${t('含有')} ${valuedesc}`
      }
    });
    return res
  }
  return res
}

export default { 
  definedVal,
  response,
  hideBtn,
  isPermission,
  PERMISSION_ADD_ALL
}